export default "__VITE_ASSET__DEHz00_d__"